<template>
	<v-app>
		<template v-if="$myStore.state.loggedIn">
			<v-toolbar app clipped-left fixed>
				<v-spacer></v-spacer>
				<v-tooltip bottom>
					<v-btn @click="logoutClick" icon slot="activator">
						<v-icon>fa-sign-out-alt</v-icon>
					</v-btn>
					<span>{{ $t('tooltips.logout') }}</span>
				</v-tooltip>
			</v-toolbar>
		</template>
		<v-content v-if="initialLoadCompleted">
			<transition name="fade">
				<router-view :key="$route.fullPath"></router-view>
			</transition>
		</v-content>
	</v-app>
</template>

<script>

export default {
	name: 'Admin',
	components: {},
	data() {
		return {
			drawer: null,
			initialLoadCompleted: false,
			breadcrumbs: []
		}
	},
	computed: {},
	watch: {
	},
	methods: {
		logoutClick() {
			let vm = this;
			this.$verify(this.$t('alerts.logoutQuestion'), (result) => {
				if (result) {
					vm.$APICall('post', 'logout', {}, (data, success) => {
						if (success) {
							vm.$myStore.commit('setUser', null);
							vm.$myStore.commit('setLoggedIn', false);
							vm.$router.push('/login');
						}
					});
				}
			});
		}
	},
	mounted() {
		let vm = this;
		this.$APICall('get', 'session', {}, (data, success) => {
			if (success) {
				vm.$myStore.commit('setUser', data);
				vm.$myStore.commit('setLoggedIn', true);
				let baseRoutes = ['login', null, ''];
				if (baseRoutes.indexOf(vm.$router.currentRoute.name) !== -1) {
					vm.$router.push('dashboard');
				}
				if (data.version != vm.$getCookie('ide3_version')) {
					vm.$setCookie('ide3_version', data.version);
					window.location.reload(true);
				}
			} else {
				vm.$myStore.commit('setUser', null);
				vm.$myStore.commit('setLoggedIn', false);
				let outsideRoutes = ['reset-password'];
				if (outsideRoutes.indexOf(vm.$router.currentRoute.name) == -1) {
					vm.$router.replace('/login');
				}
			}
			vm.initialLoadCompleted = true;
		});
	}
}
</script>

<style scoped>
</style>
